import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ConfirmModalService } from 'src/app/services/confirm-modal.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

export enum ConfirmModalStyle {
  Danger = 'danger',
  Success = 'success',
  None = 'none'
}

@Component({
  selector: 'confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit, OnDestroy {
  ConfirmModalStyle = ConfirmModalStyle;
  
  @Input() name: string;
  @Input() title: string;
  @Input() content: string;
  @Input() yes: string;
  @Input() no: string;
  @Input() style = ConfirmModalStyle.Danger;
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  show = false;
  private subscription: Subscription;

  constructor(private controller: ConfirmModalService) { }

  ngOnInit() {
    if (!this.name) {
      this.name = ConfirmModalService.DEFAULT_NAME;
    }

    this.subscription = this.controller.statusChanges.pipe(
      filter(item => item.name === this.name)
    ).subscribe(val => {
      this.show = val?.show;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onClose() {
    this.show = false;
    this.cancel.emit();
    this.controller.update(this.name, false);
  }

  onConfirm() {
    this.show = false;
    this.confirm.emit();
    this.controller.update(this.name, true);
  }
}
